import Apix from './apix';

export default Apix;